module.exports = __webpack_public_path__ + "static/media/default_sound.bd8eddb3.mp3";